import styled from "styled-components";
import { theme } from "../../theme";

export const StyledSection = styled.section`
  position: absolute;
  top: -3rem;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 600px;
  background: ${theme.backgroundColor.primaryBlack};
  z-index: -10;
  transform: skewY(-10deg);
  transform-origin: top left;
  color: ${theme.textColor.primaryWhite};
  @media (max-width: 768px) {
    top: -13rem;
  }
`;

export const StyledHeroSection = styled.section`
  color: ${theme.textColor.primaryWhite};
  padding: 6rem 3rem 3rem 3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 400px;
  h1 {
    font-size: 2.5rem;
    margin-bottom: 0rem;
  }
  img {
    width: 400px;
    height: 400px;
    -webkit-box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.27);
    -moz-box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.27);
    box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.27);
    // add hovering effect
    animation: upDown 7s ease-in-out infinite;
    @keyframes upDown {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(20px);
      }
      100% {
        transform: translateY(0);
      }
    }
  }

  span.hero-section-subtitle {
    display: block;
    margin: 1rem 0;
  }

  .hero-section-actions {
    display: flex;
    button {
      border: 1px solid ${theme.textColor.primaryWhite};
      &:first-child {
        margin-right: 1rem;
      }
    }
  }
  .typewrite {
    position: relative;
  }
  .typewrite:after {
    content: "";
    width: 1px;
    height: 50%;
    border-right: 2px solid #fff;
    animation: animated-cursor 600ms steps(29, end) infinite;
  }
  @keyframes animated-cursor {
    from {
      border-right-color: #ffffff;
    }
    to {
      border-right-color: transparent;
    }
  }
  @media (max-width: 990px) {
    img {
      width: 280px;
      height: 280px;
    }
  }
  @media (max-width: 768px) {
    padding: 0 1.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 400px;
    h1 {
      font-size: 1.5rem;
    }
    span.hero-section-subtitle {
      display: block;
      margin: 1rem 0;
      font-size: 14px;
    }
    img {
      display: none;
    }
  }
`;

export const StyledSectionTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 24px;
  h1 {
    margin: 3rem 0 10px 0;
    text-align: center;
  }
  span {
    margin-bottom: 3rem;
    text-align: center;
  }
  @media (max-width: 1100px) {
    h1 {
      font-size: 22px;
      line-height: 1.2;
      &.first-header {
        margin-top: 24px;
      }
    }
    span {
      font-size: 14px;
      margin-bottom: 1rem;
    }
  }
`;

export const StyledPrivacySection = styled.section`
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  padding-top: 34px;
  padding-bottom: 10px;
  min-height: 250px;
  background-color: black;
  position: relative;
  @media (max-width: 786px) {
    flex-direction: column;
    align-items: center;
    padding: 34px 0;
  }
`;

export const StyledPricingPlans = styled.section`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  padding: 0 24px;

  @media (max-width: 990px) {
    display: -webkit-inline-box;
    justify-content: flex-start;
    justify-content: center;
    overflow-x: auto;
    width: -webkit-fill-available;
    gap: 24px;
    margin: 0;
    padding: 0 24px;
  }
`;
